import { DBServiceOptionsWithImagesAndValidation } from '../../../../types/dbService';
import { EntryProcedureModel } from '../../../../types/EntryProcedure';
import { ProcedureModel } from '../../../../types/Procedures';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import EntryProcedure from '../../EntryProcedure';

export const prepareDeleteProcedure = ({
    procedure,
}: {
    procedure: ProcedureModel;
}) => procedure.prepareMarkAsDeleted();

export const prepareDeleteEntryProcedures = async ({
    procedureId,
    serviceOptions,
}: {
    procedureId: string;
    serviceOptions: DBServiceOptionsWithImagesAndValidation;
}): Promise<EntryProcedureModel[]> => {
    const entryProcedureService = new EntryProcedure(serviceOptions);
    const entryProcedures = await entryProcedureService.getByParam(
        'procedure_id',
        procedureId,
    );

    return entryProcedures.map((entryProcedure) =>
        entryProcedure.prepareMarkAsDeleted(),
    );
};

export const logDeleteProcedureActions = ({
    procedure,
    entryProceduresToDelete,
    logDBAction,
    tableName,
}: {
    procedure: ProcedureModel;
    entryProceduresToDelete: EntryProcedureModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Delete procedure',
        modelName: tableName,
        payload: procedure,
    });

    logDBAction({
        message: 'Delete procedure - delete entry procedures',
        modelName: tableName,
        payload: entryProceduresToDelete,
    });
};
